import React from 'react';
import { SizeMe } from 'react-sizeme';
import {
  createVideoPublicLinkApi,
  getVideoPublicLinkApi,
  updateVideoPublicLinkApi } from
'../api';
import RequestProvider from '../../RequestProvider';
import PublicUploadModalComponent from '../components/PublicUploadModal';










function PublicUploadModal(props) {
  return (
    <RequestProvider
      requests={{
        createVideoPublicLink: createVideoPublicLinkApi(),
        getVideoPublicLink: getVideoPublicLinkApi(),
        updateVideoPublicLink: updateVideoPublicLinkApi()
      }}>

      {(requests) =>
      <SizeMe>
          {({ size }) =>
        <PublicUploadModalComponent
          size={size}
          {...requests}
          {...props} />}


        </SizeMe>}

    </RequestProvider>);

}

export default PublicUploadModal;